export function getInitials(name) {
  const parts = name.replace(/^Dr\.\s*/i, "").trim().split(/\s+/);
  return parts
    .slice(0, 2)
    .map((p) => p[0]?.toUpperCase() ?? "")
    .join("");
}

export default function DoctorAvatar({ name, img, size = 44, eager = false }) {
  const initials = getInitials(name);

  if (img) {
    return (
      <img
        className="doctor-avatar"
        src={img}
        alt={name ? `${name} profile photo` : "Doctor profile photo"}
        width={size}
        height={size}
        loading={eager ? "eager" : "lazy"}
        decoding="async"
      />
    );
  }

  return (
    <span
      className="doctor-avatar-fallback"
      style={{ width: size, height: size, fontSize: Math.round(size * 0.36) }}
      aria-hidden="true"
    >
      {initials}
    </span>
  );
}
